export class LogDataTransport {
    /**
     * @abstract
     * @param {object} logData
     */
    sendLog(logData) {}
}
